/**
 * Header 2.0 search idle + typeahead drawer.
 *
 * Colour/type live in colors.js + typography.js — change those tokens,
 * then this file, not the component themes.
 */
import typography from '@amblique/king-living/app/theme/foundations/typography';

const {textStyles} = typography;

export const header2Search = {
  color: {
    text: 'brandColors.charcoal',
    title: 'brandColors.darkCharcoal',
    category: 'text.primary',
    chipBorder: 'primary.linen50',
    page: 'background.primary',
    floatLabel: 'greyscale.70',
    input: 'greyscale.100',
    rowBg: '#e9e5dd',
  },
  space: {
    afterSearch: {base: 0, lg: 4},
    popularToTrending: {base: 8, lg: 10},
    columns: {base: 8, lg: 20},
    section: {base: 4, lg: 5},
    chip: {base: 1.5, lg: 2},
    row: 1,
    rowGutter: {base: 3, lg: 4},
    rowPad: 4,
    spotlightList: {base: 5, lg: 6},
    spotlightCaption: {base: 1.5, lg: 2},
    headingToMedia: {base: 4, lg: 5},
  },
  productThumb: {
    bg: 'brandColors.secondaryBG',
    flexShrink: 0,
    h: {base: '56px', lg: '72px'},
    minH: {base: '56px', lg: '72px'},
    minW: {base: '75px', lg: '96px'},
    overflow: 'hidden',
    position: 'relative',
    w: {base: '75px', lg: '96px'},
    sx: {
      img: {
        height: '100%',
        left: 0,
        maxW: 'none',
        objectFit: 'cover',
        objectPosition: 'center',
        position: 'absolute',
        top: 0,
        width: '100%',
      },
    },
  },
  listHover: {
    '& > *': {
      transition: 'opacity 150ms ease',
    },
    // Dim siblings only while a child is hovered/focused — not the list gap.
    '&:has(> *:hover) > *:not(:hover), &:has(> *:focus-visible) > *:not(:focus-visible)': {
      opacity: 0.4,
    },
    '@media (prefers-reduced-motion: reduce)': {
      '& > *': {
        transition: 'none',
      },
    },
  },
  type: {
    section: {
      ...textStyles.bodyP1,
      color: 'brandColors.charcoal',
      fontWeight: 500,
      letterSpacing: 0,
      textTransform: 'none',
    },
    chip: {
      color: 'brandColors.charcoal',
      fontFamily: 'body',
      fontSize: 'xs',
      fontWeight: 500,
      lineHeight: '17px',
    },
    productTitle: {
      color: 'brandColors.darkCharcoal',
      fontFamily: 'body',
      fontSize: {base: '13px', lg: '14px'},
      fontWeight: 500,
      lineHeight: {base: 1.2, lg: 1.4},
    },
    productCategory: {
      color: 'text.primary',
      fontFamily: 'body',
      fontSize: {base: '11px', lg: 'xs'},
      fontWeight: 400,
      lineHeight: 1.2,
    },
    spotlightTitle: {
      ...textStyles.bodyP2,
      color: 'brandColors.charcoal',
    },
    searchField: {
      ...textStyles.headingH4,
      color: 'brandColors.charcoal',
      fontSize: {base: '14px', lg: '1.5625rem'},
      lineHeight: {base: 1.4, lg: '2rem'},
    },
    floatLabel: {
      color: 'greyscale.70',
      fontFamily: 'body',
      fontSize: '2xs',
      fontWeight: 500,
      lineHeight: 1.4,
    },
  },
};
